import React from 'react';
import { useSelector } from 'react-redux';
import { CompraClick } from '../..';

export const CompraClickProduct = () => {
  const compraClickData = useSelector((state) => state.dashboard?.compraClick) || [];

  return <CompraClick showDetails={true} compraClickData={compraClickData} />
};
